import React from 'react';
import { useAccount } from 'wagmi';

import useGameDetails from './useGameDetails.js';

function useIsWantedChainActive() {
  const gameDetails = useGameDetails();

  const account = useAccount();

  const [wantedChainIsActive, SetWhetherWantedChainIsActive] = React.useState(true);

  React.useEffect(() => {
    if (!account?.chainId || !gameDetails.wantedChain.id) return;
    DetermineWhetherWantedChainActive();
  }, [account?.chainId, gameDetails]);


  async function DetermineWhetherWantedChainActive() {
    const wantedChainID = gameDetails.wantedChain.id;
    //const wantedChainIDHexacdecimal = "0x" + wantedChainID.toString(16);
    const currentChainID = account.chainId;
    /*
    console.log({
      wID: wantedChainID,
      aID: currentChainID,
    });
    */
    SetWhetherWantedChainIsActive(currentChainID == wantedChainID);
  }


  return wantedChainIsActive;
};

export default useIsWantedChainActive;
